export default __webpack_public_path__ + "static/media/PD_logo.7b131b79.svg";